<div class="mb-3">
  @if (!expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(true)">
      <mat-icon class="icon">chevron_right</mat-icon>
      <strong>Expand for Location Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(false)">
      <mat-icon class="icon">expand_more</mat-icon>
      <strong>Location Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="content">
      <p>
        Location data shared from your EHR is used to determine patient care ownership
        and referral evidence eligibility for your 340B claim verifications. To ensure that
        claims are verified correctly, each location must be reviewed and flagged
        appropriately.
      </p>
      <p>
        Only locations with records that demonstrate valid patient care ownership or valid
        referral evidence should be marked ELIGIBLE. Locations that do not demonstrate
        valid patient care ownership or valid referral evidence should be marked
        INELIGIBLE. Any locations flagged as NEW should be reviewed and updated as
        soon as possible to ensure that all related claims are correctly worked.
      </p>

      <p>Status Definitions:</p>

      <ul>
        <li class="mb-3">
          <strong class="eligibility-status eligible">ELIGIBLE</strong> – encounters and referrals from this location will be used to satisfy
          patient care ownership requirements or as valid referral evidence and WILL count
          towards claim verifications. Eligibility is applied only for the duration of the
          location's defined eligibility period(s).
        </li>
        <li class="mb-3">
          <strong class="eligibility-status ineligible">INELIGIBLE</strong> – encounters and referrals from this location will not be used to
          satisfy patient care ownership or as valid referral evidence and WILL NOT count
          towards claim verifications. Note that an ineligible location may have previously
          held an eligibility period; only records with dates that fall within those defined
          eligibility period(s) will count towards claim verifications.
        </li>
        <li>
          <strong class="eligibility-status new">NEW</strong> – this location has not been reviewed. Encounters and referrals from this
          location will not be used to satisfy patient care ownership or as valid referral
          evidence until the status is updated. Please review and update NEW locations
          promptly to avoid gaps in claim eligibility.
        </li>
      </ul>

      <p>
        If an existing location's eligibility status changes, please update it and indicate the
        date on which that change occurred.
      </p>
    </div>
  }
</div>

